// 모든 이미지를 public/images에서 절대경로로 로딩
// const graphGreen = '/images/graph-green.png' // 이미지 파일 없음
// const graphRed = '/images/graph-red.png' // 이미지 파일 없음  
// const graphs = '/images/graphs.png' // 이미지 파일 없음
// const fullStar = '/images/fullstar.png' // 이미지 파일 없음
// const emptyStar = '/images/emptystar.png' // 이미지 파일 없음
const mainView = '/images/mainView.webp'
const graph = '/images/graph.png'
const createBot = '/images/createBot.png'
const followers = '/images/followers.png'

const crypto = '/images/crypto.jpeg'
const derivatives = '/images/derivatives.jpeg'
const options = '/images/options.jpeg'
const followerTrader = '/images/follower-center.png'
const traderBg = '/images/traderbg.png'
const avatar = '/images/avatar.png'
const securityHigh = '/images/securityHigh.png'

const darkDefault = '/images/dark_default.png'
const darkAsk = '/images/dark_ask.png'
const darkBid = '/images/dark_bid.png'
const lightDefault = '/images/light_default.png'
const lightAsk = '/images/light_ask.png'
const lightBid = '/images/light_bid.png'

const atsign = '/images/at-sign.png'
const idcard = '/images/id-card.png'
const lockalt = '/images/lock-alt.png'
const messagesquarecheck = '/images/message-square-check.png'
const pollpeople = '/images/poll-people.png'
const shieldcheck = '/images/shield-check.png'
const shieldblack = '/images/shieldblack.png'
const shieldplus = '/images/shield-plus.png'
const squareusercheck = '/images/square-user-check.png'
const usercheckalt1 = '/images/user-check-alt-1.png'
const userlockalt1 = '/images/user-lock-alt-1.png'
const x = '/images/x.png'
const nodata = '/images/nodata.png'

const callCenter = '/images/callCenter.png'
const helpCenter = '/images/helpCenter.png'
export {
	nodata,
	x,
	callCenter,
	helpCenter,
	shieldblack,
	atsign,
	idcard,
	lockalt,
	messagesquarecheck,
	pollpeople,
	shieldcheck,
	shieldplus,
	squareusercheck,
	usercheckalt1,
	userlockalt1,
	darkDefault,
	darkAsk,
	darkBid,
	lightDefault,
	lightAsk,
	lightBid,
	avatar,
	crypto,
	derivatives,
	options,
	// graphGreen, // 이미지 파일 없음
	// graphRed, // 이미지 파일 없음
	// graphs, // 이미지 파일 없음
	// fullStar, // 이미지 파일 없음
	// emptyStar, // 이미지 파일 없음
	mainView,
	graph,
	createBot,
	followers,
	followerTrader,
	traderBg,
	securityHigh,
}
